import {
    ADMIN_LEVEL_ACCESS,
    DEVELOPER_LEVEL_ACCESS,
    GROUP_LEVEL_ACCESS,
    USER_LEVEL_ACCESS,
} from 'src/components/access';
import type { IStoreTag } from 'src/constants/store/tags';
import type { IUser } from 'src/interfaces/user';
import { TConversationStoreTag } from '../components/Threads/Tags';

export const ALL_TAGS_FILTER_ID = 'all';

export const getStoreTags = (store: unknown): IStoreTag[] => {
    const tags = (store as { tags?: IStoreTag[] } | null)?.tags;
    return Array.isArray(tags) ? tags : [];
};

export const getAccessibleStoresForUser = (
    user: IUser | null | undefined,
    stores: unknown[] | null | undefined
): any[] => {
    if (!user?.accessLevel) return [];

    if (user.accessLevel === DEVELOPER_LEVEL_ACCESS) return stores || [];

    if (
        user.accessLevel === ADMIN_LEVEL_ACCESS ||
        user.accessLevel === USER_LEVEL_ACCESS
    ) {
        return user?.stores || [];
    }

    if (user.accessLevel === GROUP_LEVEL_ACCESS) {
        return (user as any)?.group?.stores || [];
    }

    return [];
};

export const normalizeStoreTagName = (name: string): string => name.trim();

/**
 * Collects store tags by name across stores. Tags keep their store-specific IDs,
 * but repeated names are displayed as a single filter option.
 */
export const collectUniqueStoreTags = (
    storesList: any[]
): TConversationStoreTag[] => {
    const uniqueTags = new Map<string, TConversationStoreTag>();

    storesList.forEach((store) => {
        getStoreTags(store).forEach((tag) => {
            const id = tag._id?.trim();
            const name = tag.name?.trim();
            if (!id || !name) return;

            const normalizedName = normalizeStoreTagName(name);
            if (uniqueTags.has(normalizedName)) return;

            uniqueTags.set(normalizedName, {
                _id: id,
                name,
                icon: tag.icon || '⚙️',
                color: tag.color,
            });
        });
    });

    return Array.from(uniqueTags.values());
};
